<template>
  <div class="home">
    <img class="k_log_logo" alt="Vue logo" src="../assets/k_log_logo.jpg" />
    <h3>Kログ</h3>
    <h6>
      日々の体温・体調を入力する事による、
      <br />信頼の仲間作りのツールです。
    </h6>
    <b-container class="mt-3 mb-3">
      <b-row align-h="center">
        <b-col cols="10">
          <b-alert variant="light" :show="isCountDay">
            <b-icon icon="exclamation-circle-fill" variant="success"></b-icon>
            {{this.countDayMessage}}
          </b-alert>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2"></b-col>
        <b-col cols="8">
          <b-button-group>
            <b-button variant="success" v-on:click="toInput()">
              <b-icon icon="clipboard" aria-hidden="true"></b-icon>入力画面へ
            </b-button>
          </b-button-group>
        </b-col>
        <b-col cols="2"></b-col>
      </b-row>
    </b-container>
    <b-container>
      <b-row>
        <b-col cols="2"></b-col>
        <b-col cols="8">
          <b-form-text class="mb-2 mt-4">
            <p style="font-size: 20px">入力履歴</p>
          </b-form-text>
        </b-col>
        <b-col cols="2">
          <b-button-group class="mb-2 mt-4">
            <b-button v-on:click="reload()">
              <b-icon
                icon="arrow-counterclockwise"
                aria-hidden="true"
                v-bind:animation="reloadAnimation()"
              ></b-icon>
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>
    </b-container>
    <HomeList :result-data="resultData.data"></HomeList>
  </div>
</template>

<script
  charset="utf-8"
  src="https://static.line-scdn.net/liff/edge/2.1/sdk.js"
></script>

<script>
// @ is an alias to /src
import HomeList from "@/components/HomeList.vue";

import "firebase/functions";
import firebase from "firebase";
// firebaseのconfigファイルの場所
import { firebaseConfig } from "../firebase/config.jsx";
// initializeAppはHomeでする
firebase.initializeApp(firebaseConfig);

const REGION_TOKYO = "asia-northeast1";

export default {
  name: "Home",
  components: {
    HomeList
  },
  data() {
    return {
      canReload: true,
      resultData: {
        data: [{ date: "取得中", fever: "取得中", features: "取得中" ,postal_code: "取得中"}]
      },
      userData: this.$store.state.userData,
      isTodayInputAlert: false,
      isTodayInputAlertPool: true,
      isCountDay: false,
      shouldCheckDay: null,
      countDay: 0,
      calDates: [],
      countDayMessage: "",
      currentView: "HomeList",
      lateRead: this.$store.state.lateRead
    };
  },
  created() {
    // this.initializeLiff() onlyGetData でする
    this.initializeLiff();
  },
  computed: {
    getLateRead() {
      return this.$store.getters.getLateRead;
    }
  },
  watch: {
    getLateRead(newState, oldState) {
      if (newState) {
        this.$router.go({ path: this.$router.currentRoute.path, force: true });
      }
    }
  },
  methods: {
    initializeLiff: function() {
      liff.init(
        {
          liffId: process.env.VUE_APP_LIFF_ID
        },
        () => {
          const idToken = liff.getContext();
          this.$store.dispatch("setLoginData", idToken);
          this.onlyGetData();
        }
      );
    },
    // onlyGetData 内で実行
    getFeatures: function(data) {
      // 症状を確認して features に格納
      for (var j = 0; j < data.length; j++) {
        data[j].features = "";
        var searchValue = [
          data[j].cough,
          data[j].breath_difficult,
          data[j].runny_nose,
          data[j].headache,
          data[j].diarrtha,
          data[j].taste_disorder
        ];
        var searchKey = ["せき", "息苦しさ", "鼻水", "頭痛", "下痢","味覚障害"];
        for (var i = 0; i < searchValue.length; i++) {
          if (searchValue[i] === true) {
            data[j].features = data[j].features + searchKey[i] + ",";
          }
        }
        if (data[j].features === "") {
          data[j].features = "なし";
        }
      }
      return data;
    },
    async onlyGetData() {
      if (this.$store.state.lateRead) {
        return;
      }
      if (this.$store.state.resultData === null) {
        this.userData.user_info = await this.$store.state.loginData;
        const onlyGetData = firebase
          .app()
          .functions(REGION_TOKYO) // Functionsのデプロイされているregion指定
          .httpsCallable(process.env.VUE_APP_ONLY_GET_DATA); // Functionsの関数名指定
        this.resultData = await onlyGetData(this.userData.user_info);
        this.resultData.data = this.getFeatures(this.resultData.data);
        this.resultData.data = this.resultData.data.map(
          (item) => {
            if(item.postal_code===""){
              item.postal_code === "未入力"
            }
            return item
          }
        )
        this.$store.dispatch("setResultData", this.resultData);
        this.alertChecker(this.resultData.data);
        return this.resultData.data;
      } else {
        console.log("null");
        // ちなみにexample DB には記入例と37.0の2つが入っている
        this.resultData = this.$store.state.resultData;
      }
    },
    toInput: function() {
      this.$router.push("input");
    },
    reloadAnimation: function() {
      if (this.canReload) {
        return "";
      } else {
        return "spin-reverse";
      }
    },
    // onlyGetData 内で実行
    alertChecker: function(data) {
      const today = new Date(Date.now() + 9 * 60 * 60 * 1000);
      const todayOrigin = parseInt(today / (24 * 60 * 60 * 1000));
      console.log(todayOrigin);
      // 当日記入確認
      for (var i = 0; i < data.length; i++) {
        var calDate = parseInt(data[i].date_key / (24 * 60 * 60 * 1000));
        this.calDates.push(calDate);
        console.log(calDate);
        if (todayOrigin === calDate) {
          this.isTodayInputAlertPool = false;
          console.log(this.isTodayInputAlertPool);
        }
      }
      this.isTodayInputAlert = this.isTodayInputAlertPool;
      // 連続記入日のチェック
      const range = (start, stop) =>
        Array.from({ length: stop - start + 1 }, (_, i) => start + i);
      var stack = parseInt(todayOrigin - 14);
      this.shouldCheckDay = range(stack, todayOrigin);
      console.log(this.shouldCheckDay);
      console.log(this.calDates);
      for (var j = 0; j < this.shouldCheckDay.length; j++) {
        if (this.calDates.includes(this.shouldCheckDay[j])) {
          console.log(this.shouldCheckDay[j]);
          this.countDay += 1;
        } else {
          this.countDay = 0;
        }
      }
      if (this.countDay !== 0) {
        this.isCountDay = true;
        this.countDayMessage =
          "あなたの連続記入日数は" + this.countDay + "日です。";
      }
      if (this.countDay >= 14) {
        this.isCountDay = true;
        this.countDayMessage = "あなたの連続記入日数は14日以上です。";
      }
      console.log(this.isTodayInputAlert);
    },
    // alertChecker 内で実行
    todayInputAlert: function() {
      return this.isTodayInputAlert;
    },
    reload: async function() {
      const reloadSleep = msec =>
        new Promise(resolve => setTimeout(resolve, msec));
      console.log(this.canReload);
      if (this.canReload) {
        this.canReload = false;
        await reloadSleep(5000);
        this.$router.go({ path: this.$router.currentRoute.path, force: true });
      }
    }
  }
};
</script>

<style>
.alert {
  margin-bottom: 0px !important;
}

.k_log_logo {
  height: 140px;
  width: 140px;
}
</style>
